import Layout from '@/layout'

const route = {
  path: '/wecomWechat',
  component: Layout,
  redirect: '/wecomWechat/index',
  alwaysShow: true, // will always show the root menu
  name: 'wecomWechat',
  meta: {
    title: '企业微信',
    icon: 'diy-QiYeWzXn',
    roles: [
      'spWorkWechat'
    ]
  },
  children: [
    // 头像配置信息
    {
      path: '/enterprisealllist/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '企微管理',
        roles: [
          'spWorkWechat.manager'
        ]
      },
      children: [
        {
          path: '/enterprise/index',
          component: () => import('@/views/enterprise/index.vue'),
          name: 'Enterprise',
          meta: {
            title: '企微企业列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.list'
            ]
          }
        },
        {
          path: '/enterpriselabel/index',
          component: () => import('@/views/enterprise/components/enterpriseLabel.vue'),
          name: 'enterpriselabel',
          meta: {
            title: '企业标签',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.list'
            ]
          },
          hidden: true
        },
        // {
        //   path: '/enterExternalemployees/index',
        //   component: () => import('@/views/enterExternalemployees/index.vue'),
        //   name: 'EnterExternalemployees',
        //   meta: {
        //     title: '外部客户列表',
        //     // icon: 'component',
        //     roles: [
        //       'spWorkWechat.spCorp.externalContactsList'
        //     ]
        //   }
        // },
        // {
        //   path: '/wechatlist/index',
        //   component: () => import('@/views/wechatlist/index.vue'),
        //   name: 'Wechatlist',
        //   meta: {
        //     title: '企微群列表',
        //     // icon: 'component',
        //     roles: [
        //       'spWorkWechat.spChatGroup.index'
        //     ]
        //   }
        // },
        {
          path: '/enterpriseAstaff/index',
          component: () => import('@/views/enterpriseAstaff/index.vue'),
          name: 'EnterpriseAstaff',
          meta: {
            title: '企微/员工列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.corpUsersList'
            ]
          }
        },
        {
          path: '/Paging/index',
          component: () => import('@/views/enterprise/components/Paging.vue'),
          name: 'Paging',
          meta: {
            title: '添加聊天',
            roles: [
              'officialAccount.index'
            ]
          },
          hidden: true
        },
        {
          path: '/employeeCorrespondencer/index',
          component: () => import('@/views/employeeCorrespondencer/index.vue'),
          name: 'EmployeeCorrespondencer',
          meta: {
            title: '员工对应客户列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.contactFollowUsers'
            ]
          }
        },
        {
          path: '/staffAccount/index',
          component: () => import('@/views/staffAccount/index.vue'),
          name: 'StaffAccount',
          meta: {
            title: '员工/公众号列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.staffOfficial.index'
            ]
          }
        },
        {
          path: '/eMicroenterprise/index',
          component: () => import('@/views/eMicroenterprise/index.vue'),
          name: 'EMicroenterprise',
          meta: {
            title: '企微小程序绑定列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.weComApplet'
            ]
          }
        },
        // {
        //   path: '/pullgroup/index',
        //   component: () => import('@/views/pullgroup/index.vue'),
        //   name: 'Pullgroup',
        //   meta: {
        //     title: '拉群设置',
        //     // icon: 'component',
        //     roles: [
        //       'spWorkWechat.groupChatSet'
        //     ]
        //   }
        // },
        {
          path: '/calllicense/index',
          component: () => import('@/views/calllicense/index.vue'),
          name: 'Calllicense',
          meta: {
            title: '企微接口调用许可订单',
            // icon: 'component',
            roles: [
              'spWorkWechat.accountAccess.index'
            ]
          }
        },
        {
          path: '/licenselist/index',
          component: () => import('@/views/licenselist/index.vue'),
          name: 'Licenselist',
          meta: {
            title: '企微用户接口调用许可',
            // icon: 'component',
            roles: [
              'spWorkWechat.accountAccess.userAccessList'
            ]
          }
        },
        {
          path: '/qiqroqe/index',
          component: () => import('@/views/qiqroqe/index.vue'),
          name: 'Qiqroqe',
          meta: {
            title: '企微二维码',
            // icon: 'component',
            roles: [
              'user_qrcode'
            ]
          }
        },
        {
          path: '/messageTemplate/friends/index',
          component: () => import('@/views/messageTemplate/friends/index.vue'),
          name: 'YrGsFriends',
          meta: {
            title: '员工好友检测',
            // icon: 'component',
            roles: [
              'spWorkWechat.userDetection.list'
            ]
          }
        }
        // {
        //   path: '/newcustomersoperate/index',
        //   component: () => import('@/views/newcustomersoperate/index.vue'),
        //   name: 'Newcustomersoperate',
        //   meta: {
        //     title: '新客户运营',
        //     // icon: 'component',
        //     roles: [
        //       'spWorkWechat.spCorp.plansList'
        //     ]
        //   }
        // }
      ]
    },
    {
      path: '/strategyalling/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '策略管理',
        roles: [
          'spWorkWechat.strategy'
        ]
      },
      children: [
        {
          path: '/enterprisemilist/index',
          component: () => import('@/views/enterprisemilist/index.vue'),
          name: 'Enterprisemilist',
          meta: {
            title: '企微策略列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.strategy.list'
            ]
          }
        },
        // {
        //   path: '/OperationStrategy/index',
        //   component: () => import('@/views/OperationStrategy/index.vue'),
        //   name: 'OperationStrategy',
        //   meta: {
        //     title: '运营策略列表',
        //     // icon: 'component',
        //     roles: [
        //       'spWorkWechat.operational_strategy.index'
        //     ]
        //   }
        // },
        {
          path: '/enterpmessagelist/index',
          component: () => import('@/views/enterpmessagelist/index.vue'),
          name: 'Enterpmessagelist',
          meta: {
            title: '企微消息列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spMessage.list'
            ]
          }
        },
        {
          path: '/atregulartime/index',
          component: () => import('@/views/atregulartime/index.vue'),
          name: 'Atregulartime',
          meta: {
            title: '定时消息推送',
            // icon: 'component',
            roles: [
              'spWorkWechat.temporaryPush'
            ]
          }
        },
        // {
        //   path: '/circlefriends/index',
        //   component: () => import('@/views/circlefriends/index.vue'),
        //   name: 'Circlefriends',
        //   meta: {
        //     title: '朋友圈定时发布',
        //     // icon: 'component',
        //     roles: [
        //       'momentsPush'
        //     ]
        //   }
        // },
        // {
        //   path: '/workWechat/index',
        //   component: () => import('@/views/workWechat/index.vue'),
        //   name: 'WorkWechat',
        //   meta: {
        //     title: '朋友圈管理',
        //     // icon: 'component',
        //     roles: [
        //       'moments'
        //     ]
        //   }
        // },
        {
          path: '/immediately/index',
          component: () => import('@/views/immediately/index.vue'),
          name: 'Immediately',
          meta: {
            title: '即时消息',
            // icon: 'component',
            roles: [
              'spWorkWechat.messagePushUp.index'
            ]
          }
        },
        {
          path: '/sourcematerialc/index',
          component: () => import('@/views/sourcematerialc/index.vue'),
          name: 'Sourcematerialc',
          meta: {
            title: '素材',
            // icon: 'component',
            roles: [
              'spMedia'
            ]
          }
        },
        {
          path: '/welcomewechatlist/index',
          component: () => import('@/views/welcomeWeChatlist/index.vue'),
          name: 'Immediately',
          meta: {
            title: '企微群欢迎语',
            // icon: 'component',
            roles: [
              'spWorkWechat.groupWelcome'
            ]
          }
        },
        {
          path: '/awaitingmaterialmenu/index',
          component: () => import('@/views/awaitingMaterialMenu/index.vue'),
          name: 'AwaitingMaterialMenu',
          meta: {
            title: '待发素材',
            // icon: 'component',
            roles: [
              'mini_material_task'
            ]
          }
        }
        // {
        //   path: '/strategiccompass/index',
        //   component: () => import('@/views/strategiccompass/index.vue'),
        //   name: 'Strategiccompass',
        //   meta: {
        //     title: '策略罗盘',
        //     // icon: 'component',
        //     roles: [
        //       'spMedia'
        //     ]
        //   }
        // },
        // {
        //   path: '/pushscript/index',
        //   component: () => {
        //     return import('@/views/messageTemplate/index.vue')
        //   },
        //   name: 'pushScript',
        //   meta: {
        //     title: '脚本推送',
        //     // icon: 'component',
        //     roles: [
        //       'spStrategy.wwScript'
        //     ]
        //   },
        //   children: [
        //     {
        //       path: '/pushCustomscript/index',
        //       component: () => import('@/views/pushCustomscript/index.vue'),
        //       name: 'pushCustomscript',
        //       meta: {
        //         title: '客户发送记录(用户)',
        //         // icon: 'component',
        //         roles: [
        //           'spStrategy.wwScript.userRecord'
        //         ]
        //       }
        //     },
        //     {
        //       path: '/pushCustomscriptcrowd/index',
        //       component: () => import('@/views/pushCustomscriptcrowd/index.vue'),
        //       name: 'pushCustomscript',
        //       meta: {
        //         title: '客户发送记录(群)',
        //         // icon: 'component',
        //         roles: [
        //           'spStrategy.wwScript.userRecord'
        //         ]
        //       }
        //     },
        //     {
        //       path: '/messagecenter/index',
        //       component: () => import('@/views/messagecenter/index.vue'),
        //       name: 'messagecenter'
        //     }
        //   ]
        // },
      ]
    },
    {
      path: '/partymanagement/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '第三方管理',
        roles: [
          'upTool.manager'
        ]
      },
      children: [
        {
          path: '/clientlist/index',
          component: () => import('@/views/clientlist/index.vue'),
          name: 'Clientlist',
          meta: {
            title: '客户端列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.upTool.client.index'
            ]
          }
        },
        {
          path: '/keywordslist/index',
          component: () => import('@/views/keywordslist/index.vue'),
          name: 'Keywordslist',
          meta: {
            title: '客户消息',
            // icon: 'component',
            roles: [
              'spWorkWechat.keywordCollect.index'
            ]
          }
        },
        {
          path: '/frequencyset/index',
          component: () => import('@/views/frequencyset/index.vue'),
          name: 'Calllicense',
          meta: {
            title: '员工消息频率设置',
            // icon: 'component',
            roles: [
              'spWorkWechat.frequency.index'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
        },
        {
          path: '/ProxyConfig/index',
          component: () => import('@/views/ProxyConfig/index.vue'),
          name: 'ProxyConfig',
          meta: {
            title: '代理管理',
            // icon: 'component',
            roles: [
              'spWorkWechat.upTool.client.index'
            ]
          }
        }
      ]
    },
    {
      path: '/groupoperations/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '群运营',
        roles: [
          'chat.manager'
        ]
      },
      children: [
        {
          path: '/pullgroup/index',
          component: () => import('@/views/pullgroup/index.vue'),
          name: 'Pullgroup',
          meta: {
            title: '拉群设置',
            // icon: 'component',
            roles: [
              'spWorkWechat.groupChatSet'
            ]
          }
        },
        {
          path: '/wechatlist/index',
          component: () => import('@/views/wechatlist/index.vue'),
          name: 'Wechatlist',
          meta: {
            title: '企微群列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spChatGroup.index'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
        }
      ]
    },
    {
      path: '/customeroperations/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '客户运营',
        roles: [
          'customer.manager'
        ]
      },
      children: [
        {
          path: '/enterExternalemployees/index',
          component: () => import('@/views/enterExternalemployees/index.vue'),
          name: 'EnterExternalemployees',
          meta: {
            title: '外部客户列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.externalContactsList'
            ]
          }
        },
        {
          path: '/newcustomersoperate/index',
          component: () => import('@/views/newcustomersoperate/index.vue'),
          name: 'Newcustomersoperate',
          meta: {
            title: '新客户运营',
            // icon: 'component',
            roles: [
              'spWorkWechat.spCorp.plansList'
            ]
          }
        },
        {
          path: '/OperationStrategy/index',
          component: () => import('@/views/OperationStrategy/index.vue'),
          name: 'OperationStrategy',
          meta: {
            title: '运营方案列表',
            // icon: 'component',
            roles: [
              'spWorkWechat.operational_strategy.index'
            ]
          }
        },
        {
          path: '/circlefriends/index',
          component: () => import('@/views/circlefriends/index.vue'),
          name: 'Circlefriends',
          meta: {
            title: '朋友圈定时发布',
            // icon: 'component',
            roles: [
              'momentsPush'
            ]
          }
        },
        {
          path: '/workWechat/index',
          component: () => import('@/views/workWechat/index.vue'),
          name: 'WorkWechat',
          meta: {
            title: '朋友圈管理',
            // icon: 'component',
            roles: [
              'moments'
            ]
          }
        },
        {
          path: '/messagecenter/index',
          component: () => import('@/views/messagecenter/index.vue'),
          name: 'messagecenter'
        }
      ]
    },
    {
      path: '/TencentAccount/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '养号配置',
        roles: [
          'account_cultivate'
        ]
      },
      children: [
        {
          path: '/TencentAccountIni/index',
          component: () => import('@/views/TencentAccountIni/index.vue'),
          name: 'AccountIni',
          meta: {
            title: '账号配置',
            // icon: 'component',
            roles: [
              'cultivate_config'
            ]
          }
        },
        {
          path: '/taskrecordrlist/index',
          component: () => import('@/views/taskrecordrlist/index.vue'),
          name: 'Taskrecordrlist',
          meta: {
            title: '任务记录',
            // icon: 'component',
            roles: [
              'job_record'
            ]
          }
        }
      ]
    },

    {
      path: '/h5app/index',
      name: 'TencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: 'H5应用',
        roles: [
          'h5.suite'
        ]
      },
      children: [
        {
          path: '/companyList/index',
          component: () => import('@/views/companyList/index.vue'),
          name: 'CompanyList',
          meta: {
            title: '企业列表',
            // icon: 'component',
            roles: [
              'h5.suite.corp'
            ]
          }
        },
        {
          path: '/companyLists/index',
          component: () => import('@/views/companyLists/index.vue'),
          name: 'CompanyLists'
        }
      ]
    },
    {
      path: '/circlefriends/sendcicle/index',
      component: () => import('@/views/circlefriends/sendcicle.vue'),
      name: 'Sendcicle',
      meta: {
        title: '新增定时发送朋友圈',
        // icon: 'component',
        roles: [
          'officialAccount.index'
        ]
      },
      hidden: true
    },
    {
      path: '/stafans/index',
      component: () => import('@/views/enterpriseAstaff/components/stafans.vue'),
      name: 'Stafans',
      meta: {
        title: '员工粉丝',
        // icon: 'component',
        roles: [
          'spWorkWechat.spCorp.corpUsersList'
        ]
      },
      hidden: true
    },
    {
      path: '/awaitingMaterialMenuadd/index',
      component: () => import('@/views/awaitingMaterialMenu/components/additenwr.vue'),
      name: 'Stafans',
      meta: {
        title: '待发素材',
        // icon: 'component',
        roles: [
          'mini_material_task'
        ]
      },
      hidden: true
    }
    // {
    //   path: '/enterprisemilist/index',
    //   component: () => import('@/views/enterprisemilist/index.vue'),
    //   name: 'Enterprisemilist',
    //   meta: {
    //     title: '企微策略列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.strategy.list'
    //     ]
    //   }
    // },
    // {
    //   path: '/enterpmessagelist/index',
    //   component: () => import('@/views/enterpmessagelist/index.vue'),
    //   name: 'Enterpmessagelist',
    //   meta: {
    //     title: '企微消息列表',
    //     // icon: 'component',
    //     roles: [
    //       // 'spWorkWechat.spMessage.list'
    //       'spWorkWechat.spMessage.list'
    //     ]
    //   }
    // },

    // {
    //   path: '/enterpriseAstaff/index',
    //   component: () => import('@/views/enterpriseAstaff/index.vue'),
    //   name: 'EnterpriseAstaff',
    //   meta: {
    //     title: '企微/员工列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.spCorp.corpUsersList'
    //     ]
    //   }
    // },
    // {
    //   path: '/enterprise/index',
    //   component: () => import('@/views/enterprise/index.vue'),
    //   name: 'Enterprise',
    //   meta: {
    //     title: '企微企业列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.spCorp.list'
    //     ]
    //   }
    // },
    // {
    //   path: '/enterprisestaff/index',
    //   component: () => import('@/views/enterprisestaff/index.vue'),
    //   name: 'Enterprisestaff',
    //   meta: {
    //     title: '企微企业员工列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.spCorp.corpUsersList'
    //     ]
    //   }
    // },
    // {
    //   path: '/enterExternalemployees/index',
    //   component: () => import('@/views/enterExternalemployees/index.vue'),
    //   name: 'EnterExternalemployees',
    //   meta: {
    //     title: '外部客户列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.spCorp.externalContactsList'
    //     ]
    //   }
    // },
    // {
    //   path: '/employeeCorrespondencer/index',
    //   component: () => import('@/views/employeeCorrespondencer/index.vue'),
    //   name: 'EmployeeCorrespondencer',
    //   meta: {
    //     title: '员工对应客户列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.spCorp.contactFollowUsers'
    //     ]
    //   }
    // },
    // {
    //   path: '/staffAccount/index',
    //   component: () => import('@/views/staffAccount/index.vue'),
    //   name: 'StaffAccount',
    //   meta: {
    //     title: '员工/公众号列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.staffOfficial.index'
    //     ]
    //   }
    // },
    // {
    //   path: '/eMicroenterprise/index',
    //   component: () => import('@/views/eMicroenterprise/index.vue'),
    //   name: 'EMicroenterprise',
    //   meta: {
    //     title: '企微小程序绑定列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.weComApplet.index'
    //     ]
    //   }
    // },
    // {
    //   path: '/clientlist/index',
    //   component: () => import('@/views/clientlist/index.vue'),
    //   name: 'Clientlist',
    //   meta: {
    //     title: '客户端列表',
    //     // icon: 'component',
    //     roles: [
    //       'spWorkWechat.upTool.client.index'
    //     ]
    //   }
    // }
    /*     {
      path: '/behavioralsource/index',
      component: () => import('@/views/behavioralsource/index.vue'),
      name: 'Behavioralsource',
      meta: {
        title: '行为源',
        // icon: 'component',
        roles: [
          'ad1.userAction.index'
        ]
      }
    } */
  ]
}

export default route
